import { type IconDefinition } from '@fortawesome/fontawesome-svg-core';

/* SOLID */
import {} from // faBars,
'@fortawesome/pro-solid-svg-icons';

/* THIN */
import {
  faBuilding as fatBuilding,
  faCircleUser as fatCircleUser,
  faChartNetwork as fatChartNetwork,
} from '@fortawesome/pro-thin-svg-icons';

/* LIGHT */
import {} from // faRocket as falRocket
'@fortawesome/pro-light-svg-icons';

/* DUOTONE */
import {} from // faUnicorn as fadUnicorn
'@fortawesome/pro-duotone-svg-icons';

export default [
  /* SOLID */
  // faBars,
  /* THIN */
  fatBuilding,
  fatChartNetwork,
  fatCircleUser,
  /* LIGHT */
  // falRocket,
  /* DUOTONE */
  // fadUnicorn,
] as IconDefinition[];

export const AF_ICON = '🦄';
